export const minuteFormatter = (
  value: number,
  unit: string,
  suffix: string,
) => {
  if (unit === 'minute') {
    const pluralSuffix = value !== 1 ? 's' : '';
    return `${value} min${pluralSuffix} ${suffix}`;
  }
  if (unit === 'second' && value < 60) {
    return `Just now`;
  }
  return undefined;
};
